import i from"styled-components";import{theme as o}from"../../../theme.js";const r=i.div`
  background-color: ${o.colors.gray[100]};
  > div {
    width: ${o.maxWidth};
    margin: 0 auto;
    padding: ${o.spacing*8}px 0;
  }
  @media screen and (max-width: ${o.breakpoints.xl}) {
    > div {
      width: 100%;
      padding: ${o.spacing*8}px ${o.spacing*4}px;
      box-sizing: border-box;
    }
  }
`,a=i.div`
  position: relative;
  margin-bottom: ${o.spacing*6}px;
  > h1 {
    text-align: center;
    margin: 0;
    font-size: 24px;
    color: ${o.colors.gray[900]};
  }
`,t=i.div`
  position: absolute;
  top: 0;
  right: 16px;
  display: flex;
  gap: ${o.spacing*2}px;
  > button {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: ${o.radius}px;
    width: 40px;
    height: 40px;
    border: none;
    background-color: ${o.colors.shades[0]};
    cursor: pointer;
    > svg {
      width: 24px;
      height: 24px;
      > g, path {
        fill: ${o.colors.gray[500]};
      }
    }
    &:hover {
      background-color: ${o.colors.gray[50]};
    }
    &:disabled {
      cursor: not-allowed;
      background-color: ${o.colors.gray[200]};
    }
    &.right {
      > svg {
        transform: rotate(-90deg);
      }
    }
    &.left {
      > svg {
        transform: rotate(90deg);
      }
    }
  }
  @media screen and (max-width: ${o.breakpoints.md}) {
    display: none;
  }
`,e=i.div`
  padding: ${o.spacing*4}px;
  border-radius: ${o.radius}px;
  min-height: 160px;
  background-color: ${o.colors.shades[0]};
  min-width: 352px;
  max-width: 352px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${o.spacing*8}px;
  flex: 1;
  scroll-snap-align: start;
  scroll-snap-stop: always;
  .author {
    display: flex;
    gap: ${o.spacing*2}px;
    align-items: center;
    > span {
      font-size: 14px;
      font-weight: 700;
      color: ${o.colors.gray[900]};
    }
  }
  .content {
    display: flex;
    flex-direction: column;
    gap: ${o.spacing*4}px;
    > p {
      margin: 0;
      font-size: 14px;
      line-height: 21px;
      color: ${o.colors.gray[500]};
      font-style: italic;
    }
    > img {
      width: 100%;
      height: auto;
      object-fit: cover;
      aspect-ratio: 16/9;
      border-radius: ${o.radius}px;
    }
  }
  &:first-child {
    margin-left: 16px;
  }
  &:last-child {
    margin-right: 16px;
  }
  @media screen and (max-width: ${o.breakpoints.md}) {
    width: 100%;
    box-sizing: border-box;
  }
`,n=i.div`
  display: flex;
  gap: ${o.spacing*4}px;
  overflow: scroll hidden;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  &::-webkit-scrollbar {
    display: none;
  }
`;export{t as ButtonsContainer,e as Card,n as CardsContainer,r as Container,a as HeaderContainer};
